import { usePractice } from "../usePractice";
import { getBrand } from "../utils/brand";
import { Helmet } from "react-helmet-async";

function Terms() {
  const { practice } = usePractice();
  const brand = getBrand(practice?.fields?.brand);

  return (
    <div className="container">
      <Helmet>
        <title>{brand.name} - Terms and Conditions</title>
      </Helmet>
      <h2 className="mb-2 text-center">Terms and Conditions</h2>
      <p>
        <strong>RELEASE AND CERTIFICATION</strong> I/We agree to release and
        indemnify Coda Group Fauntleroy LLC dba Resting Waters Aquamation
        (“Resting Waters” or “Resting Waters Aquamation”), Evvi Aftercare and
        Aquamation, the Veterinarian, and their owners, members, officers,
        directors, agents and employees, from any claim, liability, cost or
        expense resulting from their reliance on or services or other
        performance consistent with the directions, declarations,
        representations, authorizations and agreements herein. I/We agree that
        the liability of Coda Group Fauntleroy LLC, Resting Waters Aquamation,
        Evvi Aftercare and Aquamation, the Veterinarian, and their owners,
        members, officers, directors, agents and employees, including without
        limitation for negligent acts (of itself or its agents or employees), is
        limited to a refund of the aquamation fees paid by me/us. I/We have read
        and understood this document.
      </p>
      <p>
        <strong>
          TERMS AND CONDITIONS FOR AQUAMATION AUTHORIZATION FORM AQUAMATION
        </strong>{" "}
        OPTIONS Aquamation is performed to prepare the remains of the pet for
        final disposition. It is carried out by placing the pet into an
        Aquamation chamber where they remain for 20-24 hours while heated water
        and alkali break down the soft tissue, leaving only bone fragments
        (calcium compounds), teeth, and metal medical devices. The Aquamation
        can be done in the following ways, including Individual with Remains
        Returned or Individual with Scattering Service. Residual (Incidental)
        Commingling: Unavoidable incidental commingling between aquamations that
        occurs despite a best effort to recover all cremains from each
        aquamation. This will occur to varying degrees with any type of
        aquamation or cremation. Due to the nature of the Aquamation process,
        any possessions or materials, such as collars or tags that are left with
        the animal will be removed prior to Aquamation and disposed of. The
        Owner/Authorizing Agent understands that arrangements must be made to
        remove any such personal possessions or materials prior to the time that
        the animal is transported to Resting Waters/Evvi Aftercare and
        Aquamation. After the aquamated remains are removed from the Aquamation
        chamber, all inorganic material will be separated and removed from the
        animal bone fragments by visible selection. The Owner/Authorizing Agent
        understands and authorizes Resting Waters/Evvi Aftercare and Aquamation
        to dispose of these materials in a non-recoverable manner, including
        recycling. When the aquamated remains are removed from the Aquamation
        chamber, the skeletal remains often will contain recognizable bone
        fragments. After the bone fragments are dried, they will be mechanically
        processed, pulverized. The process of crushing or grinding may cause
        incidental commingling of the remains with the residue from the
        processing of previously aquamated remains. These granulated particles
        of unidentifiable dimensions, which are virtually unrecognizable as
        animal remains, will then be placed into a designated container based on
        the type of Aquamation identified above Individual with Remains Returned
        or Individual with Scattering Service. You may request that we do not
        pulverize the aquamated remains after the aquamation process.
      </p>
      <p>
        An <strong>INDIVIDUAL</strong> Aquamation with{" "}
        <strong>REMAINS RETURNED</strong> is a partitioned Aquamation procedure
        during which your companion’s body is placed in a six-sided, stainless
        steel enclosure inside the Aquamation chamber while other bodies are
        present within the Aquamation chamber inside of their own six-sided
        stainless steel enclosure. The aquamated remains of your pet are to be
        returned to the owner(s) within 2 weeks of the Aquamation process. One
        complimentary fur clipping, one complimentary ink paw print, and one
        complimentary clay paw impression included with the service by request.
        Scatter vessel urn included with the service.
      </p>
      <p>
        An <strong>INDIVIDUAL</strong> Aquamation with SCATTERING SERVICE is a
        partitioned Aquamation procedure during which your companion’s body is
        placed in a six-sided, stainless steel enclosure inside the Aquamation
        chamber while other bodies are present within the Aquamation chamber
        inside of their own six-sided stainless steel enclosure. The remains are
        not returned to you but lovingly scattered by us in the Puget Sound. No
        memorial item capturing is included however, a $30 Remembrance Item
        Package may be purchased and includes one fur clipping, one ink paw
        print, and one clay paw impression.
      </p>
      <p>
        <strong>FINAL DISPOSITION OF AQUAMATED REMAINS</strong> Following the
        Aquamation, the Owner/Authorizing Agent directs Coda Group Fauntleroy
        LLC dba Resting Waters Aquamation and/or Evvi Aftercare and Aquamation
        to undertake the actions set forth on the Authorization for Final
        Disposition Form to arrange the final disposition of the aquamated
        remains. Remains shall only be released, delivered, mailed or scattered
        in a dignified manner, in accordance with the law, and with expressed
        written consent of the Owner/Authorizing Agent. If the aquamated remains
        are shipped at any time, the Owner/Authorizing Agent directs that Coda
        Group Fauntleroy LLC dba Resting Waters Aquamation and/or Evvi Aftercare
        and Aquamation utilize registered U.S. mail with a return receipt. The
        Owner/Authorizing Agent understands that if no arrangements for the
        final disposition of the aquamated remains have been made within sixty
        (60) days after the Aquamation or if the Owner/Authorizing Agent has not
        taken delivery of or caused the delivery of the aquamated remains, or in
        the event the arrangements of the final disposition have not been
        carried out within the sixty (60) day period because of the inaction of
        a party other than Coda Group Fauntleroy LLC dba Resting Waters
        Aquamation and/or Evvi Aftercare and Aquamation or Veterinarian, Coda
        Group Fauntleroy LLC dba Resting Waters Aquamation and/or Evvi Aftercare
        and Aquamation or Veterinarian may dispose of the aquamated remains in
        any dignified manner, including scattering.
      </p>
    </div>
  );
}

export default Terms;
